const isNull = <V>(value: V | null | undefined): value is null | undefined =>
  value === undefined || value == null;

const isEmpty = (value: unknown): value is null | undefined =>
  isNull(value) || (typeof value === 'string' && value.trim().length === 0);

const nvl = <T>(value: T | null | undefined, defaultValue: T): T =>
  isEmpty(value) ? defaultValue : value;

const isNotEmpty = <T>(value: T | null | undefined): value is T =>
  !isEmpty(value);

const NOT_DEFINED = '_NOT_DEFINED_';

function getErrorMessage(e: unknown): string {
  if (e instanceof Error) {
    return e.message;
  }
  if (typeof e === 'string') {
    return e;
  }
  return String(e);
}

function isNullEqual(a: unknown, b: unknown) {
  if (isNull(a) && isNull(b)) {
    return true;
  }
  return a === b;
}

function shrink(value = '', len = 40): string {
  if (value && value.length > len) {
    return value.substring(0, len);
  }
  return value;
}

function isStrNumEqual(left: unknown, right: unknown) {
  if (left === right) return true;
  if (typeof left === 'number') {
    left = String(left);
  }
  if (typeof right === 'number') {
    right = String(right);
  }
  return left === right;
}

export {
  NOT_DEFINED,
  getErrorMessage,
  isEmpty,
  isNotEmpty,
  isNull,
  isNullEqual,
  isStrNumEqual,
  nvl,
  shrink,
};
